module.exports = __webpack_public_path__ + "img/icn_brand6.67599934.svg";